// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DealAndDocResolver } from '@services/resolvers/deal-and-doc-resolver';
import { UserResolver } from '@services/resolvers/user.resolver';
import { BuyerSignComponent } from './buyer-sign/buyer-sign.component';
import { BuyerUploadComponent } from './buyer-upload/buyer-upload.component';
import { BuyerViewComponent } from './buyer-view/buyer-view.component';
import { IntellicheckUploadComponent } from 'src/app/shared/intellicheck-upload/intellicheck-upload.component';

const routes: Routes = [
    {
        path: 'upload',
        resolve: {
            deal: DealAndDocResolver,
            user: UserResolver,
        },
        component: BuyerUploadComponent,
        data: {
            title: 'Upload A Document',
        },
    },
    {
        path: 'uploadIdn',
        component: IntellicheckUploadComponent,
        resolve: {
            deal: DealAndDocResolver,
            user: UserResolver,
        },
        data: {
            title: 'Scan and Upload',
        },
    },
    {
        path: 'sign',
        resolve: {
            deal: DealAndDocResolver,
            user: UserResolver,
        },
        component: BuyerSignComponent,
        data: {
            title: 'Sign A Document',
        },
    },
    {
        path: 'view',
        resolve: { deal: DealAndDocResolver },
        component: BuyerViewComponent,
        data: {
            title: 'View a Document',
        },
    },
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full',
    },
];
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class BuyerDocRoutingModule {}
